import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import DailyPlanEmailWindow from "./dailyPlanEmailWindow";
import InvoicePackingEmailWindow from "./invoicePackingEmailWindow";
import VGMEmailWindow from "./VGMEmailWindow";
import store from "../store/Store";
import { filter } from "lodash";
import ContainerMasterEmailWindow from "./ContainerMasterEmailWindow";

function MainEmailWindow() {
	const [type, setType] = useState("DailyEmailWindow");
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessDailyData, setFilteredUserAccessDailyData] =
		useState([]);
	const [filteredUserAccessInvData, setFilteredUserAccessInvData] = useState(
		[]
	);
	const [filteredUserAccessVGMData, setFilteredUserAccessVGMData] = useState(
		[]
	);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (
			filter(userData, { MenuName: "Daily Plan Email", View: 1 }).length > 0
		) {
			setFilteredUserAccessDailyData(
				filter(userData, { MenuName: "Daily Plan Email", View: 1 })
			);
		}
		if (
			filter(userData, { MenuName: "Invoice Packing Email", View: 1 }).length >
			0
		) {
			setFilteredUserAccessInvData(
				filter(userData, { MenuName: "Invoice Packing Email", View: 1 })
			);
		}
		if (filter(userData, { MenuName: "VGM Email", View: 1 }).length > 0) {
			setFilteredUserAccessVGMData(
				filter(userData, { MenuName: "VGM Email", View: 1 })
			);
		}
	}, [userData]);

	return (
		<>
			<div className="flex-row mb-12 counterHeaderResponsive">
				<h1>Share Email</h1>
			</div>
			<Tabs
				activeKey={type}
				style={{
					marginTop: "-20px",
				}}
				onSelect={(k) => {
					setType(k);
				}}
			>
				{filteredUserAccessDailyData.length > 0 && (
					<Tab eventKey="DailyEmailWindow" title="Daily Email">
						<DailyPlanEmailWindow type={type} />
					</Tab>
				)}
				{
					<Tab eventKey="ContainerMasterWindow" title="Container Master Email">
						<ContainerMasterEmailWindow type={type} />
					</Tab>
				}
				{filteredUserAccessInvData.length > 0 && (
					<Tab eventKey="InvoiceEmailWindow" title="Invoice Email">
						<InvoicePackingEmailWindow type={type} />
					</Tab>
				)}
				{filteredUserAccessVGMData.length > 0 && (
					<Tab eventKey="VGMWindow" title="VGM Email">
						<VGMEmailWindow type={type} />
					</Tab>
				)}
			</Tabs>
		</>
	);
}

export default MainEmailWindow;
